<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br/>
            <h2 class="text-center">วิธีการชำระเงิน</h2>
            <div class="row">
                <div class="col offset-sm-6 col-sm-6">
                    <div class="row form-group">
                        <div class="col col-6">
                            <label class="col-form-label text-right">ยอดที่ต้องชำระ</label>
                        </div>
                        <div class="col col-6">
                            <label class="col-form-label">
                                <strong>
                                    {{ form.amount | currency }}
                                </strong>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Cash -->
            <div class="form-group row">
                <div class="col pl-5">
                    <input class="form-check-input"
                           type="checkbox"
                           id="type-cash"
                           v-model="transactions.checkCash"/>
                    <label class="form-check-label" for="type-cash">
                        เงินสด
                    </label>
                </div>
                <template v-if="transactions.checkCash">
                    <div class="col">
                        <input type="number"
                               placeholder="จำนวนเงิน"
                               class="form-control"
                               v-model="transactions.cash.amount"
                               step="0.01"/>
                    </div>
                </template>
            </div>
            <hr>
            <!-- Cheque -->
            <div class="form-group row">
                <div class="col pl-5">
                    <input class="form-check-input"
                           type="checkbox"
                           id="type-cheque"
                           v-model="transactions.checkCheque"/>
                    <label class="form-check-label" for="type-cheque">
                        เช็ค
                    </label>
                </div>
            </div>
            <template v-if="transactions.checkCheque">
                <template v-for="(data,index) in transactions.cheque">
                    <div class="form-group row">
                        <div class="col" :for="`ref_no${index}`">
                            <input type="text"
                                   :id="`ref_no${index}`"
                                   placeholder="หมายเลขเช็ค"
                                   v-model="data.ref_no"
                                   class="form-control"/>
                        </div>
                        <div class="col" :for="`date${index}`">
                            <date-picker
                                :id="`date${index}`"
                                v-model="data.date"
                                class="w-100"
                                :format="changeFormat"
                                :lang="lang"
                                placeholder="ลงวันที่">
                            </date-picker>
                        </div>
                        <div class="col" :for="`bank_name${index}`">
                            <b-form-select v-model="data.cheque_bank_id"
                                           :options="optionBankType">
                            </b-form-select>
                        </div>
                        <div class="col">
                            <multiselect
                                v-model="data.bank_branch"
                                :options="optionBranch"
                                :customLabel="labelBranch"
                                :show-labels="false"
                                placeholder="สาขา"
                                track-by="id">
                            </multiselect>
                        </div>
                        <div class="col" :for="`amount${index}`">
                            <input type="number"
                                   :id="`amount${index}`"
                                   placeholder="จำนวนเงิน"
                                   v-model="data.amount"
                                   class="form-control"
                                   step="0.01"/>
                        </div>
                        <div class="col flex-grow-0">
                            <button class="btn btn-danger"
                                    v-if="transactions.cheque.length > 1"
                                    @click="removeCheque(index)">
                                <icon name="minus"></icon>
                            </button>
                        </div>
                    </div>
                </template>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-primary" @click="addCheque">
                            <icon name="plus"></icon>
                            เพิ่มรายการ
                        </button>
                    </div>
                </div>
            </template>
            <hr>
            <!-- Transfer -->
            <div class="form-group row">
                <div class="col pl-5">
                    <input class="form-check-input"
                           type="checkbox"
                           id="type-transfer"
                           v-model="transactions.checkTransfer">
                    <label class="form-check-label" for="type-transfer">
                        เงินโอน
                    </label>
                </div>
            </div>
            <template v-if="transactions.checkTransfer">
                <template v-for="(data,index) in transactions.transfer ">
                    <div class="form-group row">
                        <div class="col" :for="`ref_no${index}`">
                            <multiselect
                                v-model="data.bank"
                                :options="optionBank"
                                :customLabel="customLabelBank"
                                :show-labels="false"
                                placeholder="เลขบัญชีธนาคาร"
                                track-by="id">
                            </multiselect>
                        </div>
                        <div class="col" :for="`date${index}`">
                            <date-picker
                                :id="`date${index}`"
                                class="w-100"
                                v-model="data.date"
                                :format="changeFormat"
                                :lang="lang"
                                placeholder="ลงวันที่">
                            </date-picker>
                        </div>
                        <div class="col" :for="`amount${index}`">
                            <input type="number"
                                   :id="`amount${index}`"
                                   placeholder="จำนวนเงิน"
                                   v-model="data.amount"
                                   class="form-control"
                                   step="0.01"/>
                        </div>
                        <div class="col flex-grow-0">
                            <button class="btn btn-danger"
                                    @click="removeTransfer(index)"
                                    v-if="transactions.transfer.length > 1">
                                <icon name="minus"></icon>
                            </button>
                        </div>
                    </div>
                </template>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-primary" @click="addTransfer">
                            <icon name="plus"></icon>
                            เพิ่มรายการ
                        </button>
                    </div>
                </div>
            </template>
            <hr>
            <!-- Transfer -->
            <div class="form-group row">
                <div class="col pl-5">
                    <input class="form-check-input"
                           type="checkbox"
                           id="type-close"
                           v-model="transactions.checkClose">
                    <label class="form-check-label" for="type-close">
                        ปิดหนี้
                    </label>
                </div>
            </div>
            <template v-if="transactions.checkClose">
                <textarea class="form-control" v-model="transactions.closeRemark"></textarea>
            </template>
            <hr>
            <!-- Fee, offset, and pledge. -->
            <div class="row">
                <div class="col col-sm-6">
                    <div class="row form-group">
                        <div class="col col-5 text-right">
                            <label class="col-form-label">รับเงิน เกิน</label>
                        </div>
                        <div class="col col-6">
                            <input type="number"
                                   v-model="form.overpay"
                                   placeholder="รับเงิน เกิน"
                                   class="form-control"
                                   step="0.01">
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col col-5 text-right">
                            <label class="col-form-label">รับเงิน ขาด</label>
                        </div>
                        <div class="col col-6">
                            <input type="number"
                                   v-model="form.arrears"
                                   placeholder="รับเงิน ขาด"
                                   class="form-control"
                                   step="0.01">
                        </div>
                    </div>
                    <!--<div class="row form-group">-->
                    <!--<div class="col col-5 text-right">-->
                    <!--<label class="col-form-label text-right">ชำระด้วยเงินมัดจำ</label>-->
                    <!--</div>-->
                    <!--<div class="col col-6">-->
                    <!--<input type="number"-->
                    <!--placeholder="ชำระด้วยเงินมัดจำ"-->
                    <!--v-model="form.pledge_amount"-->
                    <!--class="form-control"-->
                    <!--step="0.01">-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
                <div class="col col-sm-6">
                    <div class="row form-group">
                        <div class="col col-5 text-right">
                            <label class="col-form-label">Fee/ค่าธรรมเนียม</label>
                        </div>
                        <div class="col col-6">
                            <input type="number"
                                   placeholder="Fee/ค่าธรรมเนียม"
                                   v-model="form.fee_amount"
                                   class="form-control"
                                   step="0.01">
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <!-- Summary -->
            <div class="form-group row">
                <div class="col col-sm-6">
                    <label>
                        ยอดที่ต้องชำระ
                    </label>
                    <h2 class="form-control-plaintext">
                        {{ calculateTransaction > 0 ? (form.amount - calculateTransaction) : 0 | currency }}
                    </h2>
                </div>

                <div class="col col-sm-6 text-right">
                    <label>
                        รวมยอดเงินที่ชำระ
                    </label>
                    <h2 class="form-control-plaintext">
                        {{ calculateTransaction ? calculateTransaction : 0 | currency }}</h2>
                </div>
            </div>
            <div class="col text-center">
                <button type="button" v-if="form.id"
                        @click="showCreditModal"
                        class="btn btn-default next">
                    <icon name="file-alt"></icon>
                    บันทึกเครดิต
                </button>
                &nbsp&nbsp
                <template v-if="form.id && canViewSuperAdmin && form.payoff_status_id">
                    <button type="button"
                            @click="approveInvoicePayoff"
                            :disabled="isSubmit"
                            class="btn btn-success">
                        <icon name="print"></icon>
                        อนุมัติและพิมพ์
                    </button>
                    &nbsp&nbsp
                    <button type="button"
                            @click="submitPayoff('print')"
                            :disabled="isSubmit"
                            class="btn btn-default">
                        <icon name="print"></icon>
                        บันทึกและพิมพ์
                    </button>
                    &nbsp&nbsp
                </template>
                <template v-else>
                    <!--action = print-->
                    <button @click="submitPayoff('save')"
                            type="button"
                            :disabled="isSubmit"
                            class="btn btn-success">
                        <icon name="save"></icon>
                        บันทึก
                    </button>
                </template>
                &nbsp&nbsp
                <button @click="cancelSubmit"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
            <br/>
            <!--invoice payoff transaction-->
            <b-modal hide-header hide-footer ref="credit_customer">
                <save-credit-customer @submit="SubmitCreditCustomer">
                </save-credit-customer>
            </b-modal>
            <!--confirm modal-->
            <b-modal hide-header hide-footer ref="confirm_credit_customer">
                <confirm-modal :msg="msg" @submit="confirmCreditCustomer"></confirm-modal>
            </b-modal>
        </div>
        <b-modal hide-header hide-footer ref="loading" no-close-on-backdrop no-close-on-esc>
            <loading :msg="msg_loading" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import DatePicker from "vue2-datepicker"
import moment from "moment";
import SaveCreditCustomer from "./SaveCreditCustomer";

import {canViewSuperAdmin} from "../../../util/Permissions";
import ConfirmModal from "../../Utility/ConfirmModal";
import Loading from "../../Utility/Loading";

export default {
    name: "invoice-payoff-transaction",
    props: {
        payoff_status_id: {default: null},
    },
    components: {
        Loading,
        ConfirmModal,
        SaveCreditCustomer,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            test_save: [],
            status_loading: '',
            msg_loading: '',
            msg: '',
            isSaveCredit: false,
            isSubmit: false,
            optionBranch: [],
            taxOptions: [
                {
                    text: '0%',
                    value: 0
                },
                {
                    text: '7%',
                    value: 1
                },
            ],
            items: [
                {
                    text: "รายการตัดชำระ",
                    to: {name: "payoff-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            optionBankForCheque: [
                {text: 'กรุณาเลือกธนาคาร', value: ""},
                {text: 'OUB (ธนาคารยูโอบี)', value: 1},
                {text: 'KBank (ธนาคารสิกร)', value: 2},
                {text: 'TMB (ธนาคารทหารไทย)', value: 3},
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            details: []
        }
    },
    created() {
        this.$store.dispatch("Bank/getBankAll");
        this.$store.dispatch("Common/getBankType");
        this.$store.dispatch("Common/getBankBranch").then(res => {
            this.optionBranch = res;
        });
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            form: state => {
                return state.InvoicePayoff.form
            },
            transactions: state => {
                return state.InvoicePayoff.transactions
            },
            user: state => {
                return state.Auth.user;
            },
            optionBank: state => {
                return state.Bank.bank_all;
            },
            optionBankType: state => {
                return [
                    {
                        value: null,
                        text: "เลือกธนาคาร"
                    },
                    ...state.Common.bank_type.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
        }),
        calculateTransaction() {
            let sum_amount = 0;
            let transactions = [];
            //เงินสด
            if (this.transactions.checkCash) {
                if (this.transactions.cash.amount) {
                    transactions.push(this.transactions.cash);
                }
            }
            //เช็ค
            if (this.transactions.checkCheque) {
                this.transactions.cheque.forEach(cheque => {
                    if (cheque.ref_no && cheque.cheque_bank_id && cheque.bank_branch) {
                        this.optionBankType.forEach(data => {
                            if (data.value == cheque.cheque_bank_id) {
                                cheque.bank_name = data.text
                            }

                        });
                        if (!cheque.date) {
                            const currentDate = moment().format("YYYY-MM-DD");
                            cheque.date = currentDate;
                        } else {
                            cheque.date = moment(cheque.date).format("YYYY-MM-DD")
                            let date_year = moment(cheque.date).format('YYYY'); //get year
                            if (date_year <= 2000) {
                                let current_year = moment().format("YYYY");
                                cheque.date = moment(cheque.date).format(+current_year + "-MM-DD")
                            }
                        }
                        if (!cheque.amount) {
                            cheque.amount = "";
                        }
                        transactions.push(cheque);
                    }
                });
            }
            //เงินโอน
            if (this.transactions.checkTransfer) {
                this.transactions.transfer.forEach(transfer => {
                    if (transfer.bank) {
                        transfer.bank_id = transfer.bank.id;
                        //console.log(transfer.bank_id);
                        if (!transfer.date) {
                            let currentDate = moment().format("YYYY-MM-DD");
                            transfer.date = currentDate;
                        } else {
                            transfer.date = moment(transfer.date).format("YYYY-MM-DD")
                            let date_year = moment(transfer.date).format('YYYY'); //get year
                            if (date_year <= 2000) {
                                let current_year = moment().format("YYYY");
                                transfer.date = moment(transfer.date).format(+current_year + "-MM-DD")
                            }
                        }
                        if (!transfer.amount) {
                            transfer.amount = "";
                        }
                        transactions.push(transfer);
                    }
                });
            }
            let price = 0;
            //console.log(transactions);
            sum_amount = transactions.reduce((carry, detail) => {
                if (detail.amount) {
                    price = detail.amount
                } else {
                    price = 0;
                }
                return carry + parseFloat(price);
            }, 0);

            if (this.form.overpay) { //เงินเกิน
                sum_amount = sum_amount - parseFloat(this.form.overpay);
            }
            if (this.form.arrears) { //เงินขาด
                sum_amount = sum_amount + parseFloat(this.form.arrears);
            }
            if (this.form.fee_amount) { //ค่าธรรมเนียม
                sum_amount = sum_amount + parseFloat(this.form.fee_amount);
            }
            return parseFloat(sum_amount);
        }
    },
    methods: {
        customLabelBank(option) {
            return `${option.account_number} - ${option.name}`
        },
        labelBranch(option) {
            return `${option.branch_code} - ${option.name}`
        },
        showCreditModal() {
            let sale_id = "";
            if (this.form.sale) {
                sale_id = this.form.sale.id;
            }
            this.$store.dispatch("Seller/getCustomerFromSale", sale_id);
            this.$refs.credit_customer.show();
        },
        hideCreditModal() {
            this.$refs.credit_customer.hide();
        },
        showConfirmCreditModal() {
            this.$refs.confirm_credit_customer.show();
        },
        hideConfirmCreditModal() {
            this.$refs.confirm_credit_customer.hide();
        },
        confirmCreditCustomer(value) {
            if (value) {
                this.isSaveCredit = true;
                this.submitPayoff('print');
            }
            this.hideConfirmCreditModal();
        },
        submitDetailsInvoice() {
            let customer = [];
            let billing = [];
            this.form.user_id = this.user.id;
            if (this.form.customer && this.form.customer.length > 0) {
                this.form.customer.forEach(data => {
                    customer.push(data.id);
                });
                this.form.customer_id = customer.toString();
            }
            if (this.form.billing.length > 0) {
                this.form.billing.forEach(data => {
                    billing.push(data.id);
                });
                this.form.billing_id = billing.toString();
            }

            //set details
            let details = [];
            this.form.details.forEach(invoice => {
                invoice.forEach(detail => {
                    if (detail.receive_status || detail.receive_amount_status) {
                        if (!detail.amount) {
                            detail.amount = 0
                        }
                        let balance = parseFloat(detail.remaining_payoff) - parseFloat(detail.amount);
                        if (balance < 0) {
                            balance = 0;
                        }
                        let data = {
                            invoice_id: detail.invoice_id,
                            customer_id: detail.customer_id,
                            billing_id: detail.billing_id,
                            date: detail.date,
                            remaining_payoff: detail.remaining_payoff,
                            receive_status: detail.receive_status,
                            receive_amount_status: detail.receive_amount_status,
                            amount: detail.amount,
                            balance: balance,
                        };
                        details.push(data);
                    }
                })
            });
            //set data
            if (this.form.date) {
                this.form.date = moment(this.form.date).format("YYYY-MM-DD")
            } else {
                this.form.date = ""
            }
            this.details = details;
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        approveInvoicePayoff() {
            this.isSubmit = true;
            this.showLoadingModal();
            this.msg_loading = "กำลังอัพเดตข้อมูล กรุณารอสักครู่";
            this.status_loading = 1;
            let data = {
                payoff_number: this.form.payoff_number,
                date: this.form.date,
            }
            this.test_save = data;
            this.$store.dispatch("InvoicePayoff/approveStatus", {
                id: this.form.id,
                data: data,
            }).then(payoff => {
                if (payoff) {
                    this.saveAndPrint(payoff, 'approve');
                } else {
                    this.msg_loading = "อัพเดตข้อมูลไม่สำเร็จ";
                    this.status_loading = 3;
                }
            }).catch(() => {
                this.msg_loading = "อัพเดตข้อมูลไม่สำเร็จ";
                this.status_loading = 3;
            });
        },
        goToPayoffList() {
            this.$router.push({name: "payoff-list"})
            this.$store.dispatch("InvoicePayoff/clearDataForm");
            this.$store.dispatch("InvoicePayoff/clearTransaction");
        },
        submitPayoff(action) {
            this.isSubmit = true;
            this.form.transactions = [];
            if (this.transactions.checkCash) {
                if (this.transactions.cash.amount) {
                    this.form.transactions.push(this.transactions.cash);
                }
            }
            if (this.transactions.checkCheque) {
                this.transactions.cheque.forEach(cheque => {
                    if (cheque.ref_no && cheque.cheque_bank_id && cheque.bank_branch) {
                        if (!cheque.date) {
                            const currentDate = moment().format("YYYY-MM-DD");
                            cheque.date = currentDate;
                        } else {
                            cheque.date = moment(cheque.date).format("YYYY-MM-DD")
                        }
                        if (!cheque.amount) {
                            cheque.amount = "";
                        }
                        cheque.bank_branch_id = cheque.bank_branch.id;
                        this.form.transactions.push(cheque);
                    }
                });
            }
            if (this.transactions.checkTransfer) {
                this.transactions.transfer.forEach(transfer => {
                    if (transfer.bank) {
                        transfer.bank_id = transfer.bank.id;
                        if (!transfer.date) {
                            let currentDate = moment().format("YYYY-MM-DD");
                            transfer.date = currentDate;
                        } else {
                            transfer.date = moment(transfer.date).format("YYYY-MM-DD")
                        }
                        if (!transfer.amount) {
                            transfer.amount = 0;
                        }
                        this.form.transactions.push(transfer);
                    }
                });
            }
            let paid = 0;
            if (this.transactions.checkClose && !this.transactions.closeRemark) {
                alert("กรุณากรอกหมายเหตุ ปิดหนี้")
                this.isSubmit = false;
                return false;
            } else if (this.transactions.checkClose && this.transactions.closeRemark) {
                let close = {
                    transaction_type_id: 4,
                    cheque_bank_id: null,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                    bank: null,
                    bank_id: "",
                    remark: ""
                };
                paid = this.form.amount;
                close.amount = this.form.amount;
                close.remark = this.transactions.closeRemark;
                this.form.transactions.push(close);
            } else {
                paid = parseFloat(this.calculateTransaction).toFixed(2);
            }

            //คำนวนยอดที่รับมา
            let pay = this.form.transactions.reduce((carry, detail) => {
                return carry + parseFloat(detail.amount);
            }, 0);
            let amount = parseFloat(this.form.amount).toFixed(2);
            // let paid =  parseFloat(this.calculateTransaction).toFixed(2);
            let validate_paid = paid > 0 ? parseFloat(amount) - parseFloat(paid) : 0; //ตรวจสอบยอดเงินว่าจ่ายครบ

            //เชค รับเงินเกิน - รับเงินขาด
            if (this.form.overpay) { //เงินเกิน
                pay = pay - parseFloat(this.form.overpay);
            }
            if (this.form.arrears) { //เงินขาด
                pay = pay + parseFloat(this.form.arrears);
            }
            if (this.form.fee_amount) { //ค่าธรรมเนียม
                pay = pay + parseFloat(this.form.fee_amount);
            }
            if (this.form.amount < 1) {
                this.isSubmit = false;
                alert("กรุณากรอกจำนวนเงินที่ต้องการชำระ");
            } else if (validate_paid !== 0) {
                this.isSubmit = false;
                alert("ยอดชำระไม่ถูกต้อง")
            } else if (this.form.payoff_status_id && this.form.overpay > 0 && !this.isSaveCredit) {
                this.msg = 'คุณบันทึกเครดิตเงินเกินแล้ว ใช่หรือไม่';
                this.showConfirmCreditModal();
                this.isSubmit = false;
            } else {
                this.showLoadingModal();
                this.msg_loading = 'กำลังบันทึกข้อมูล กรุณารอสักครู่';
                this.status_loading = 1;
                this.submitDetailsInvoice();
                //save
                if (this.form.payoff_status_id == 2) {
                    this.form.payoff_status_id = 1;
                }
                let data = {
                    id: this.form.id,
                    date: this.form.date,
                    payoff_number: this.form.payoff_number,
                    payoff_status_id: this.form.payoff_status_id,
                    user_id: this.form.user_id,
                    draft_user_id: this.form.draft_user_id,
                    sale_id: this.form.sale.id,
                    customer_id: this.form.customer_id,
                    billing_id: this.form.billing_id,
                    total: this.form.total,
                    amount: this.form.amount,
                    balance: this.form.balance,
                    is_sell: this.form.is_sell,
                    acc: this.form.acc,
                    pledge_amount: this.form.pledge_amount,
                    fee_amount: this.form.fee_amount,
                    overpay: this.form.overpay,
                    arrears: this.form.arrears,
                    transactions: this.form.transactions,
                    details: this.details
                };
                this.test_save = data;
                //console.log(data)
                // save to api
                this.$store.dispatch("InvoicePayoff/saveInvoicePayoff", {
                    id: this.form.id,
                    data: data,
                }).then(res => {
                    if (res.hasOwnProperty('failed')) {
                        this.hideLoadingModal();
                        alert(res.failed);
                        return 0;
                    }
                    if (action == 'print') {
                        this.form.id = res.id;
                        this.saveAndPrint(res.id, 'print');
                    }
                    this.$store.dispatch("InvoicePayoff/setInvoicePayoff", {
                        transaction_type_id: ""
                    }).then(() => {
                        this.msg_loading = 'บันทึกข้อมูลสำเร็จ';
                        this.status_loading = 2;
                        this.$router.push({name: "payoff-list"});
                    });

                }).catch(() => {
                    this.showLoadingModal();
                    this.msg_loading = 'บันทึกข้อมูลไม่สำเร็จ';
                    this.status_loading = 3;
                    this.isSubmit = false;
                })
            }
        },
        cancelSubmit() {
            this.$router.push({name: "invoice-payoff",});
        },
        addCheque() {
            this.transactions.cheque = [
                ...this.transactions.cheque,
                {
                    transaction_type_id: 1,
                    cheque_bank_id: "",
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                }
            ]
        },
        addTransfer() {
            this.transactions.transfer = [
                ...this.transactions.transfer,
                {
                    transaction_type_id: 2,
                    cheque_bank_id: "",
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                }
            ]
        },
        removeCheque(index) {
            this.transactions.cheque = this.transactions.cheque.filter(
                (cheque, itemIndex) => index !== itemIndex
            )
        },
        removeTransfer(index) {
            this.transactions.transfer = this.transactions.transfer.filter(
                (cheque, itemIndex) => index !== itemIndex
            )
        },
        SubmitCreditCustomer(value) {
            this.hideCreditModal();
            if (value) {
                this.submitDetailsInvoice();
                let data = {
                    id: this.form.id,
                    date: this.form.date,
                    payoff_number: this.form.payoff_number,
                    payoff_status_id: this.form.payoff_status_id,
                    user_id: this.user.id,
                    draft_user_id: this.form.draft_user_id,
                    sale_id: this.form.sale.id,
                    customer_id: this.form.customer_id,
                    billing_id: this.form.billing_id,
                    total: value.credit,
                    amount: value.credit,
                    balance: value.credit,
                    is_credit_customer: true,
                    details: this.details
                };
                //console.log(data);
                this.showLoadingModal();
                this.msg_loading = 'กำลังบันทึกเครดิต กรุณารอสักครู่';
                this.status_loading = 1;
                this.$store.dispatch("InvoicePayoff/savePayoffCreditCustomer", data).then(res => {
                    this.$store.dispatch("InvoicePayoff/saveCreditCustomer", value).then(() => {
                        this.isSaveCredit = true;
                        if (res) {
                            this.saveAndPrint(res.id, 'credit');
                        }
                    }).catch(err => {
                        this.isSaveCredit = false;
                        this.showLoadingModal();
                        this.msg_loading = 'บันทึกเครดิตไม่สำเร็จ';
                        this.status_loading = 3;
                    });
                }).catch(err => {
                    this.isSaveCredit = false;
                    this.showLoadingModal();
                    this.msg_loading = 'บันทึกเครดิตไม่สำเร็จ';
                    this.status_loading = 3;
                });
            }
        },
        //save print rv to print
        saveAndPrint(id, action) {
            this.$store.dispatch("InvoicePayoff/printInvoicePayoffById", {
                id,
                user_id: this.user.id,
            }).then(url => {
                if (url) {
                    window.open(url, '_blank');
                    this.hideLoadingModal();
                    if (action != 'credit') {
                        this.goToPayoffList();
                    }
                } else {
                    this.msg_loading = 'ไม่สามารถพิมพ์ RV ได้';
                    this.status_loading = 3;
                }
            }).catch(() => {
                this.msg_loading = 'ไม่สามารถพิมพ์ RV ได้';
                this.status_loading = 3;
            })
        },
    }
}
</script>

<style scoped>

</style>
